import { Entry } from '../types'

import PACKAGES from './packages'
import WEBSITES from './websites'

const TOOLS: Entry[] = [...PACKAGES, ...WEBSITES]

export default TOOLS
